module.exports = __webpack_public_path__ + "img/Capture.old7.298ab28d.jpg";